import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Fredoka%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22preload%22:false,%22weight%22:[%22600%22,%22700%22]}],%22variableName%22:%22printRound%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Fredoka', 'Fredoka Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
